import React, { useEffect, useContext } from 'react';

import SvgIcon from 'src/react_components/svg-icon';

import { CategoryTab, CommentCategory } from '../annotator-types';
import { AnnotatorSidebarContext, AnnotatorSidebarDispatchContext } from './annotator-sidebar-context';

type Props = {
  categories: Map<string, CategoryTab>;
  open: boolean;
  selectCategory: (category: string) => void;
};

const CollapsedNavigation = ({ categories, open, selectCategory }: Props): React.JSX.Element => {
  // Get active category and dispatch function
  const active = useContext(AnnotatorSidebarContext);
  const dispatch = useContext(AnnotatorSidebarDispatchContext);

  // Set styles for navigation tabs
  const setStyles = (category: CategoryTab): string => [
    'annotator-navigation-tab d-flex align-items-center justify-content-center m-0',
    category.icon, category.id === active ? 'active' : ''
  ].filter(Boolean).join(' ');

  // Set the active category
  useEffect((): void => {
    selectCategory(CommentCategory[active]);
  }, [active]);

  return (
    <div
      aria-hidden={open}
      className="annotator-collapsed-navigation d-flex flex-column"
    >
      {Array.from(categories.values()).map((category) => (
        <button
          key={`collapsed-${category.id}`}
          type="button"
          aria-current={category.id === active}
          aria-describedby={`tooltip-${category.id}`}
          className={setStyles(category)}
          onClick={() => dispatch({ type: 'set', payload: category.id })}
        >
          {/* Icon */}
          <div className="icon-container d-flex align-items-center justify-content-center">
            <SvgIcon icon={category.icon} className="icon-md m-0" />
          </div>

          {/* Tooltip */}
          <span id={`tooltip-${category.id}`} className="annotator-tooltip">
            {category.title}
          </span>
        </button>
      ))}
    </div>
  );
};

export default CollapsedNavigation;
